jQuery(function($) {
    
	/******************************************/
		/********** VAR-----------/
	/******************************************/

  /****** LIGHTBOX MEMBER **** */
  
  $('.TeamMember-Item--js').each(function(_i, elt){
    $(elt).featherlight(
      {
      targetAttr : 'data-destination-lightbox',
      persist:false,    
      otherClose : 'span.close-container',
      openSpeed:      400,                   /* Duration of opening animation */
     closeSpeed:     400,   afterOpen: function(event){
      $(this.$instance).addClass('ready_to_display'); // alert class of content
    } 
    });
    
  });


     var $collection = $('.SectionInView');
    $collection.each(function () {
       new Waypoint.Inview({
          element: this,
          enter: function(direction) {
            $(this.element).addClass('to_anim');
            // console.log(this.element.id + ' enter');
          },
          entered: function(direction) {
            // console.log(this.element.id + ' entered');
          },
          exit: function(direction) {
           
          },
          exited: function(direction) {
             $(this.element).removeClass('to_anim');
            // console.log(this.element.id + ' exited');
          }
       });
    });



	var LARGEUR_MAX_MOBILE = 768;
	var header = $("#masthead") ,l_window, h_header, slideIndex,offsetTop,h_top_header = header.height(), width_map, height_map;
    
    if (Modernizr.svgclippaths) {
      l_window = $(window).width();
       var map1 = $('#map1'), map2 = $('#map2');
      /* **************************************************  */
      /* Contrôle width and height #map */
      /* **************************************************  */
      if(l_window > LARGEUR_MAX_MOBILE){

        width_map = parseInt(map1.parent().width()+parseInt(40*map1.parent().width()/100));
        height_map = width_map;

      }else{
          width_map = parseInt(l_window - 60);
          height_map = 400;
      }
      map1.width(width_map);
      map1.height(height_map);
      map2.width(width_map);
      map2.height(height_map);
  }

    $( window ).resize(function() {
     l_window = $(window).width();
       if(l_window > LARGEUR_MAX_MOBILE){

        width_map = parseInt(map1.parent().width()+parseInt(40*map1.parent().width()/100));
        height_map = width_map;

      }else{
          width_map = parseInt(l_window - 60);
          height_map = 400;
      }
      map1.width(width_map);
      map1.height(height_map);
      map2.width(width_map);
      map2.height(height_map);
  });


    /* **************************************************  */
      /* CLICK ON SCROLL BTN */
   /* **************************************************  */

    $(".BtnToScroll-js").click(function(e){
         e.preventDefault();
         offsetTop = $("#expertise").offset().top-h_top_header - 50;
         $('html, body').stop().animate({ 
          scrollTop: offsetTop
      }, 600);
    });


    /* **************************************************  */
  /* OUVRGETURE / FERMETURE DES DESCRIPTIONS LONGUES DANS LES EQUIPES */
  /* **************************************************  */
  $('.TeamMember-Item-Content').hide();
  $(".btn-memberDesc-js").click(function(e){

    
    if($(this).attr('aria-expanded') == "false"){
      $(this).attr('aria-expanded',"true");
      $(this).html($(this).attr('data-txt-close'));
    
    }else{
      $(this).attr('aria-expanded',"false");
     $(this).html($(this).attr('data-txt-open'));
    }

      $(this).parent().prev().slideToggle(500);
  });

   /* **************************************************  */
  /* NICSELECT */
  /* **************************************************  */
  $('.to_nicedropdown-js').niceSelect();


 $("#footer-menu > li.menu-item-has-children > a, #primary-menu > li.menu-item-has-children > a").click(function(e){
     e.preventDefault();
     $(this).parent().toggleClass('focus');
  });


  $DiapoHomeTxt2 =  $('.HomeSlideWTitle-js').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      speed: 500,
     // fade: true,
      draggable:true,
      infinite:false,
      dots:true,
      adaptiveHeight: true,
      // HEIGHT 
    //  waitForAnimate: false,
     // lazyLoad:"progressive",
     cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)"
    });

  // On before slide change, active le bon titre de menu
  $DiapoHomeTxt2.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $(".MenuLeftDiapo a").removeClass('active');
    $(".MenuLeftDiapo a").eq(parseInt(nextSlide)).addClass('active');
  });

  
  $(".MenuLeftDiapo a").click(function(e){
       offsetTop = $('#HomeSlideWTitle').offset().top-h_top_header - 0;
         $('html, body').stop().animate({ 
          scrollTop: offsetTop
      }, 600);

        e.preventDefault();
        slideIndex = $(this).index();
        $DiapoHomeTxt2.slick('slickGoTo', parseInt(slideIndex));
    });


 $text_btn = $('.menu-toggle--text');

 $(".menu-toggle").click(function(e){
      if($(this).attr('aria-expanded') == 'true'){
        $('body').addClass('open_menu');
        $text_btn.text($(this).attr('data-text-close'));
      }else{
         $('body').removeClass('open_menu');
         $text_btn.text($(this).attr('data-text-open'));
         $('#primary-menu li').removeClass('focus');
      }
   });  

 });